import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';

import { Flex } from 'Components/Base';

const BarWrapper = styled(Flex)`
  white-space: nowrap;
  overflow: visible;
  align-items: center;
  justify-content: center;
`;

const MasteryDistributionBar = ({ lv1, lv2, lv3, lv4 }) => {
  const theme = useContext(ThemeContext);

  const getColor = lv => {
    switch (lv) {
      case 1:
        return theme.colors.masteryLV1;
      case 2:
        return theme.colors.masteryLV2;
      case 3:
        return theme.colors.masteryLV3;
      case 4:
        return theme.colors.masteryLV4;
      default:
        return '';
    }
  };

  return (
    <Flex height={20} style={{ border: '1px solid black' }}>
      <BarWrapper width={`25%`} backgroundColor={getColor(1)}>
        {lv1} %
      </BarWrapper>
      <BarWrapper width={`25%`} backgroundColor={getColor(2)}>
        {lv2} %
      </BarWrapper>
      <BarWrapper width={`25%`} backgroundColor={getColor(3)}>
        {lv3} %
      </BarWrapper>
      <BarWrapper width={`25%`} backgroundColor={getColor(4)}>
        {lv4} %
      </BarWrapper>
    </Flex>
  );
};

MasteryDistributionBar.propTypes = {
  lv1: PropTypes.number.isRequired,
  lv2: PropTypes.number.isRequired,
  lv3: PropTypes.number.isRequired,
  lv4: PropTypes.number.isRequired,
};

export default MasteryDistributionBar;
